import GainLossesIncomeDetail from './GainLossesIncomeDetailView'

export const GainAndLossesContainer: React.FC = () => {
  return <GainLossesIncomeDetail />
}
